import smaresLogo from './smares_logo.png';
import harajiLogo from './haraji_logo.png';
import shoppingLogo from './shopping_logo.png';
import smaresPartnerLogo from './smares_partner_logo.png';
import bursaMetroLogo from './bursa_metro_logo.svg';
import ustadLogo from './ustad_logo.png';
import taskTrackerLogo from './tasktracker_logo.png';
import stringzLogo from './stringz_logo.png';
import stringzBackground from './stringz_bg.png';
import sspLogo from './ssp_logo.svg';

let smaresBackground, smaresPartnerBackground, bursaMetroBackground;

if (window.devicePixelRatio > 1) {
	smaresBackground = require('./smares_bg@2x.jpg');
	smaresPartnerBackground = require('./smares-partner-bg@2x.png');
	bursaMetroBackground = require('./bursa_metro_bg@2x.jpg');
} else {
	smaresBackground = require('./smares_bg.jpg');
	smaresPartnerBackground = require('./smares-partner-bg.png');
	bursaMetroBackground = require('./bursa_metro_bg.jpg');
}

const harajiBackground = smaresBackground;
const shoppingBackground = smaresBackground;

export {
	smaresLogo,
	smaresBackground,
	harajiLogo,
	harajiBackground,
	shoppingLogo,
	shoppingBackground,
	smaresPartnerLogo,
	smaresPartnerBackground,
	bursaMetroLogo,
	bursaMetroBackground,
	ustadLogo,
	taskTrackerLogo,
	sspLogo,
	stringzLogo,
	stringzBackground
};



// WEBPACK FOOTER //
// ./src/assets/images/products/index.js